import hd, { Unit } from "humanize-duration";

export function humanizeDuration(milliseconds: number, units: Unit[] = ["y", "mo", "d", "h", "m"]) {
  return hd(milliseconds, { round: true, units });
}
